import { useEffect } from "react";
import { useFirstSubChapterId } from "@/hooks/course/useFirstSubChapterId";
import { useCourseDetailStore } from "@/stores/courseDetailStore";

/**
 * Mirrors chapter-intro content unveil onto TOC focus — highlights the first
 * subchapter while the stacked intro route stays selected.
 */
const useSyncIntroTocFocus = (contentRevealed: boolean) => {
  const firstSubchapterId = useFirstSubChapterId();
  const setFocusedNodeId = useCourseDetailStore(
    (state) => state.setFocusedNodeId
  );

  useEffect(() => {
    if (contentRevealed && firstSubchapterId) {
      setFocusedNodeId(firstSubchapterId);
    } else {
      setFocusedNodeId(null);
    }

    return () => {
      setFocusedNodeId(null);
    };
  }, [contentRevealed, firstSubchapterId, setFocusedNodeId]);
};

export { useSyncIntroTocFocus };
